import { useAuth, useSignIn } from '@clerk/clerk-react';
import { showErrorNotification } from '@vrplatform/theme';
import { parseAsString, useQueryState } from '@vrplatform/query-params';
import { useCallback, useEffect } from 'react';

export function useSignInToken() {
  const { signOut, isSignedIn } = useAuth();
  const { signIn, setActive: setSignInActive } = useSignIn();

  const [token, setToken] = useQueryState('__clerk_ticket', parseAsString);

  // Handle email with password flow
  const loginWithToken = useCallback(
    async (tok: string) => {
      if (!signIn) return console.error('no sign in with token');

      if (isSignedIn) await signOut();

      await signIn
        .create({
          strategy: 'ticket',
          ticket: tok,
        })
        .then((result) => {
          if (result.status === 'complete') {
            setSignInActive({ session: result.createdSessionId });
          }
        })
        .catch((err) => {
          const errorMessage =
            err.errors?.[0]?.longMessage || 'Please try again.';
          console.error('error', errorMessage);
          setToken(null);
          showErrorNotification({
            title: "We couldn't sign you up.",
            message: errorMessage,
          });
        });
    },
    [signIn, isSignedIn, signOut, setSignInActive, setToken]
  );

  useEffect(() => {
    if (token && !isSignedIn) loginWithToken(token);
  }, [token, isSignedIn, loginWithToken]);

  return {
    tokenIsActive: !!token,
  };
}
